<template>
  <v-card
    :class="[routePath.length ? 'clickable' : '', 'dashboard-info-card']"
    :style="{ '--bottom-color': bottomColor }"
    @click="onClick"
  >
    <v-card-text class="card-content">
      <h4 class="text-muted text-center box-text">{{ labelText }}</h4>
      <h3 class="text-center card-value">
        {{ value }}
      </h3>
    </v-card-text></v-card
  >
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    bottomColor: {
      type: String,
      default: "#ff3a3a",
    },
    routePath: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      if (!this.routePath.length) return;
      else this.$router.push(this.routePath);
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

.dashboard-info-card {
  border-radius: 5px;
  border-bottom: 5px solid var(--bottom-color, #ff3a3a);
  min-height: 110px;
  height: 100%;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-content {
  padding: 1rem !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.box-text {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.card-value {
  font-size: 1.5rem;
  font-weight: 600;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

@media (max-width: 767.98px) {
  .box-text {
    font-size: 0.8rem;
  }
  
  .card-value {
    font-size: 1.25rem;
  }
  
  .card-content {
    padding: 0.75rem !important;
  }
}

@media (max-width: 575.98px) {
  .box-text {
    font-size: 0.75rem;
  }
  
  .card-value {
    font-size: 1.1rem;
  }
}
</style>
